import React from 'react';
import PropTypes from 'prop-types';
import Input from 'components/common/Input';
import { Card } from 'react-bootstrap';

const Descriptions = ({ register, errors }) => {
 return (
  <Card className="mb-3 bg-transparent border shadow-none">
   <Card.Body className="fs--1">
    <Input
     type="textarea"
     label={
      <div className="">
       <h5 className="mb-0 text-primary">Descripcion corta</h5>
       <small className="mb-0 fs--1 text-700">
        Las aclaraciones en la separación son importantes en acuerdos de compraventa de bienes. Detallan términos y condiciones
        específicos acordados por las partes.
       </small>
      </div>
     }
     name="shortDescription"
     errors={errors}
     formGroupProps={{
      className: 'mb-3'
     }}
     formControlProps={{
      ...register('shortDescription', {
       required: 'Debe especificar una descripcion corta del proyecto del proyecto'
      }),
      //defaultValue: data?.shortDescription,
      rows: 2,
      size: 'sm'
     }}
    />

    <Input
     type="textarea"
     label={
      <div className="">
       <h5 className="mb-0 text-primary">Descripcion</h5>
       <small className="mb-0 fs--1 text-700">
        Las aclaraciones en la separación son importantes en acuerdos de compraventa de bienes. Detallan términos y condiciones
        específicos acordados por las partes.
       </small>
      </div>
     }
     name="description"
     errors={errors}
     formGroupProps={{
      className: 'mb-3'
     }}
     formControlProps={{
      ...register('description', {
       required: 'Debe especificar una descripcion para el proyecto'
      }),
      //defaultValue: data?.description,
      rows: 6,
      size: 'sm'
     }}
    />
   </Card.Body>
  </Card>
 );
};

Descriptions.propTypes = { register: PropTypes.func, errors: PropTypes.object };

export default Descriptions;
